import { render, staticRenderFns } from "./manageRule.vue?vue&type=template&id=20fd7c76&scoped=true"
import script from "./manageRule.vue?vue&type=script&lang=js"
export * from "./manageRule.vue?vue&type=script&lang=js"
import style0 from "./manageRule.vue?vue&type=style&index=0&id=20fd7c76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd7c76",
  null
  
)

export default component.exports